import React from 'react'
import PropTypes from 'prop-types'

import { PageTitle } from 'Components/PageTitle'
import { ActionLinks } from './ActionLinks'
import { TimeLine } from './TimeLine'
import BreadcrumbsRenderer from '../../../Components/BreadcrumbsRenderer/BreadcrumbsRenderer'
import { getBreadcrumbs } from './util'
import { authorization } from '../../../Module/Auth/Auth'

const Header = props => {
  const breadcrumbsData = getBreadcrumbs({
    mission: props.mission,
    city: props.mission.cityPlan.city,
    fromCityScreen: false,
    match: props.match,
  })
  return (
    <div>
      <BreadcrumbsRenderer
        icon={breadcrumbsData.icon}
        items={breadcrumbsData.items}
      />
      <PageTitle>{props.mission.code}</PageTitle>
      {!authorization.isSpy() && <ActionLinks {...props} />}
      <TimeLine mission={props.mission} />
    </div>
  )
}

Header.propTypes = {
  mission: PropTypes.object.isRequired,
}

export { Header }
